import { Document } from '../../jurisdiction/jurisdiction.domain';
import { IntegratedGridProtectionDocument } from './integratedGridProtectionDocument';
import { GridApplicationDocumentTypes } from './enums/grid-application-document-types.enum';

export class GridPowerPlantProtection {
  constructor() {
    this.integrated_grid_protection_documents = [];
    this.central_grid_protection_documents = [];
  }

  id: number;
  central_grid_protection_documents: Document[];
  integrated_grid_protection_documents: IntegratedGridProtectionDocument[];
}
